import Select from "react-select";
import { useTranslation } from "react-i18next";
import { PiAirplaneInFlightLight } from "react-icons/pi";
import { capitalizeFirstLetter } from "helpers/common";
import { SlLocationPin } from "react-icons/sl";
import { dotPulse } from "ldrs";
dotPulse.register();

const AutoCompleteSelect = ({
    options,
    value,
    onInputChange,
    isLoading = false,
    onChange,
    defaultValue,
    selectedOption,
    name,
    onMenuOpen,
    onMenuClose,
}) => {
    const { t } = useTranslation();
    return (
        <Select
            options={options}
            isClearable={true}
            styles={flightCustomStyles}
            formatOptionLabel={
                name === "flight"
                    ? FlightFormatOptionLabel
                    : hotelFormatOptionLabel
            }
            components={
                name === "flight"
                    ? { SingleValue: FlightSingleValue }
                    : { SingleValue: HotelSingleValue }
            }
            inputValue={value}
            onInputChange={onInputChange}
            isLoading={isLoading}
            loadingMessage={() => (
                <div className=" flex items-center gap-2 w-full justify-center">
                    Loading
                    <l-dot-pulse
                        size="33"
                        speed="1.3"
                        color="gray"
                    ></l-dot-pulse>
                </div>
            )}
            filterOption={null}
            value={selectedOption}
            noOptionsMessage={() => t("noOptionsAvailable")}
            placeholder={
                name === "flight" ? t("selectLocation") : t("whereAreYouGoing")
            }
            onChange={onChange}
            defaultValue={defaultValue}
            onMenuOpen={onMenuOpen}
            onMenuClose={onMenuClose}
        />
    );
};

export default AutoCompleteSelect;

const FlightSingleValue = ({ data }) => (
    <div className="absolute z-30 top-1">
        {data.city_name} ({data.iata})
    </div>
);

const HotelSingleValue = ({ data }) => (
    <div className="absolute z-30 top-1">{data.description.split("-")[0]}</div>
);

// flight
const flightCustomStyles = {
    container: (styles) => ({
        ...styles,
    }),
    control: (base, { isFocused }) => ({
        ...base,
        fontSize: "1rem",
        fontWeight: 500,
        padding: "",
        outline: isFocused ? "none" : "none",
        boxShadow: isFocused ? "none" : "none",
        transition: "all 0.3s ease-in-out",
        backgroundColor: "transparent",
        border: "none",
        borderColor: "transparent",
    }),

    option: (styles, { isHovered, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused
                ? "#f8f9fa"
                : isHovered
                ? "red"
                : "white",
            cursor: "pointer",
            color: "var(--bs-gray-500)",
            fontSize: "1rem",
            fontWeight: 400,
            padding: "0",
            border: "none",
            margin: "0",
        };
    },
    menu: (styles) => ({
        ...styles,
        fontSize: "1rem",
        fontWeight: 400,
        borderRadius: "0.5rem",
        padding: "0",
        border: "1px solid rgba(var(--bs-primary-rgb), 0.7) !important",
        scrollbarWidth: "4px",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        transition: "all 0.3s ease-in-out",
        boxSizing: "border-box",
    }),
    loadingIndicator: (styles) => ({
        ...styles,
        display: "none",
    }),
    input: (styles) => ({
        ...styles,
        border: "none !important",
        width: "100%",
        backgroundColor: "transparent",
        cursor: "pointer",
    }),

    placeholder: (styles) => ({
        ...styles,
        backgroundColor: "transparent",
    }),

    indicatorSeparator: (base) => ({
        ...base,
        width: "0 !important",
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 0,
        cursor: "pointer",
    }),
    valueContainer: (base) => ({
        ...base,
        paddingInlineEnd: "1.5rem",
        border: "none",
        backgroundColor: "transparent",
    }),

    singleValue: (styles) => ({
        ...styles,
        width: "100%",
        background: "transparent",
        border: "none !important",
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        display: "none",
    }),
};

const FlightFormatOptionLabel = (option) => {
    return (
        <div className="flex  items-start justify-between  border-b p-2.5">
            <div className="flex items-start gap-2 ">
                <PiAirplaneInFlightLight size={22} />
                <div className="">
                    <div className="font-semibold text-sm ">
                        {option?.airport_name}
                    </div>
                    <div className="text-xs text-paragraph-color">
                        {capitalizeFirstLetter(
                            option?.country_name?.toLowerCase()
                        )}
                        ,{option?.city_name}
                    </div>
                </div>
            </div>
            <div className="font-semibold text-sm ms-1">{option?.iata}</div>
        </div>
    );
};

const hotelFormatOptionLabel = (option) => {
    return (
        <div className="flex items-center gap-2 p-2.5 border-b">
            <SlLocationPin size={18} />
            <div className="">
                <div className="font-semibold text-sm ">
                    {option.description.split("-")[0]}
                </div>
                <div className="text-xs text-paragraph-color">
                    {option.description}
                </div>
            </div>
        </div>
    );
};
